module.exports = __webpack_public_path__ + "static/media/img-horizontal-unemployment.c59611c1.png";